import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/marketing/Nav";
import { Hero } from "@/components/marketing/Hero";
import { Marquee } from "@/components/marketing/Marquee";
import { PartnerStrip } from "@/components/marketing/PartnerStrip";
import { Manifesto } from "@/components/marketing/Manifesto";
import { Services } from "@/components/marketing/Services";
import { ServiceSpotlights } from "@/components/marketing/ServiceSpotlights";
import { HeartFilm } from "@/components/marketing/HeartFilm";
import { Partnerships } from "@/components/marketing/Partnerships";
import { PracticeIntegration } from "@/components/marketing/PracticeIntegration";
import { Leadership } from "@/components/marketing/Leadership";
import { CtaFooter } from "@/components/marketing/CtaFooter";

export default function Landing() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-ivory min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <PartnerStrip />
      <Manifesto />
      <Services />
      <ServiceSpotlights />
      <HeartFilm />
      <Leadership />
      <Partnerships />
      <PracticeIntegration />
      <CtaFooter />
    </div>
  );
}
